import * as React from 'react';
import { KeyCode } from '@rc-component/util';
const onKeyDown = (event) => {
    const { keyCode } = event;
    if (keyCode === KeyCode.ENTER) {
        event.stopPropagation();
    }
};
const FilterDropdownMenuWrapper = React.forwardRef((props, ref) => (React.createElement("div", { className: props.className, onClick: (e) => e.stopPropagation(), onKeyDown: onKeyDown, ref: ref, role: "presentation" }, props.children)));
if (process.env.NODE_ENV !== 'production') {
    FilterDropdownMenuWrapper.displayName = 'FilterDropdownMenuWrapper';
}
export default FilterDropdownMenuWrapper;
